import { createReducer, on } from '@ngrx/store';
import { CreateUserAccountType } from '../../shared/enums';
import { RequestCreateUserAccount, ResponseCreateUserAccount } from 'src/app/shared/interfaces/createUserAccount.interface';
import { CreateUserAccountActions } from '../actions';

export interface CreateUserAccountState {
    response: ResponseCreateUserAccount;
    request: RequestCreateUserAccount;
    error: any;
}

export const CreateUserAccountInitialState: CreateUserAccountState = {
    response: null,
    request: null,
    error: null
};

const _createUserAccountReducer = createReducer(
    CreateUserAccountInitialState,

    on(CreateUserAccountActions.getCreateUserAccount, (state, { request }) => ({
        ...state,
        request: null,
        error: null
    })),

    on(CreateUserAccountActions.getCreateUserAccountSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(CreateUserAccountActions.getCreateUserAccountError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(CreateUserAccountActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function createUserAccountReducer(state, action) {
    if (action.type === CreateUserAccountType.CREATE_USER_ACCOUNT) {
        state = undefined;
    }
    return _createUserAccountReducer(state, action);
}
